import { useStore } from 'dg-web-shared/lib/Flux';
import { InputContext } from 'dg-web-shared/tb-ui/inputs/InputContext.ts';
import {
    LabeledToggle,
    ToggleType,
} from 'dg-web-shared/tb-ui/toggle/LabeledToggle.tsx';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { SlideInPortalId } from '../root/components/PortalSlidein';
import { EditFormSlideIn } from './EditForm';
import { EditFormState } from './EditFormState';
import { GetLoginData } from './state/LoginsState';
import { Spinner } from 'dg-web-shared/ui/Spinner';

export function StatusEditFormSlideIn(props: {
    portal: SlideInPortalId;
    title: React.ReactNode;
    open: boolean;
    login: GetLoginData | null;
    onClose: () => void;
}) {
    const { storeState } = useStore(s => ({
        edit: new EditFormState.StateSlice(s).state,
        legacyUpdater: s.legacyUpdater,
    }));

    if (!props.login) {
        return (
            <EditFormSlideIn isSaveable={false} {...props}>
                <Spinner />
            </EditFormSlideIn>
        );
    }

    const deactivated =
        storeState.edit.deactivated === null
            ? props.login.deactivated
            : storeState.edit.deactivated;

    return (
        <EditFormSlideIn
            isSaveable={deactivated !== props.login.deactivated}
            {...props}
        >
            <LabeledToggle
                type={ToggleType.checkbox}
                context={InputContext.form}
                label={
                    <Localized
                        de="Inaktiv"
                        fr="Pas actif"
                        it="Non attivo"
                        en="Deactivated"
                    />
                }
                selected={deactivated}
                onClick={() => {
                    storeState.legacyUpdater(
                        args => EditFormState.writeDeactivated(args!),
                        !deactivated,
                    );
                }}
            />
        </EditFormSlideIn>
    );
}
